module.exports = __webpack_public_path__ + "static/img/1.dd47ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/1.png
// module id = tdx5
// module chunks = 0